import React from "react";

import AdFoxAdaptive from "../adfoxBlocks/AdFoxAdaptive";

/**
 * Adfox-плейсмент из конфига БД.
 *
 * `AdFoxAdaptive` ждёт исторический кортеж `[options, devices, breakpoints]`,
 * поэтому payload из БД разворачивается в него здесь.
 */
export function AdfoxAdapter({ entry, className = "adfox" }) {
    if (!entry || !entry.containerId) {
        return null;
    }

    const options = [
        {
            ownerId: entry.ownerId,
            containerId: entry.containerId,
            params: { ...entry.params },
        },
    ];

    return <AdFoxAdaptive options={options} className={className} />;
}

export default AdfoxAdapter;
